export const metaDataTableActions = [
  {
    name: 'saveItemInMetaDataTable',
    label: 'Save Item in Meta Data Table',
    args: [
      {
        name: 'metaDataCollection',
        label: 'Select Meta Data Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'targetDataCollection',
        label: 'Select Target Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'metaDataMapping',
        label: 'Select Mapping',
        type: 'dropdown',
        optionsType: 'collectionMetaDataMappingApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'updateItemInMetaDataTable',
    label: 'Update Item in Meta Data Table',
    args: [
      {
        name: 'metaDataCollection',
        label: 'Select Meta Data Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'targetDataCollection',
        label: 'Select Target Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'metaDataMapping',
        label: 'Select Mapping',
        type: 'dropdown',
        optionsType: 'collectionMetaDataMappingApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'deleteItemInMetaDataTable',
    label: 'Delete Item in Meta Data Table',
    args: [
      {
        name: 'metaDataCollection',
        label: 'Select Meta Data Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'targetDataCollection',
        label: 'Select Target Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'metaDataMapping',
        label: 'Select Mapping',
        type: 'dropdown',
        optionsType: 'collectionMetaDataMappingApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'mapAllDataInMetaDataTable',
    label: 'Map All Data in Meta Data Table',
    args: [
      {
        name: 'metaDataCollection',
        label: 'Select Meta Data Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'targetDataCollection',
        label: 'Select Target Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'metaDataMapping',
        label: 'Select Mapping',
        type: 'dropdown',
        optionsType: 'collectionMetaDataMappingApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message (Optional)',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message (Optional)',
        type: 'text',
        value: '',
      },
    ],
  },
];
